import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Injectable, OnDestroy } from '@angular/core';
import { RouterPathAction } from '../action/router-path.action';
import { RouterPathInfo } from '../../../models/router-path-info';
import { CloseRoute } from '../../../models/close-route';
import { MenuService } from '../../menu/service/menu.service';
import { CurrentContextService } from '../../current-context/service/current-context.service';
import { DomainService } from '../../domain/service/domain.service';
import { Url } from '../../../models/url';
import { AppHeadTitleAndIconService } from '../../../services/app-head-title-and-icon/app-head-title-and-icon.service';

@Injectable({
  providedIn: 'root'
})
export class RouterPathService implements OnDestroy {
private subs: Subscription[] = [];
public lastUrl?: string;
public currentUrl?: string;

constructor(
  private routerPathAction: RouterPathAction,
  private currentContextService: CurrentContextService,
  private menuService: MenuService,
  public router: Router,
  private route: ActivatedRoute,
  private domainService: DomainService,
  private appHeadTitleAndIconService: AppHeadTitleAndIconService
  ) { }

  onInit() {
    this.subs.push(this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(({urlAfterRedirects}: NavigationEnd) => {
        this.lastUrl = this.currentUrl;
        this.currentUrl = urlAfterRedirects;

        const currentDomainCode = this.currentContextService.getCurrentDomain();
        const routerPathInfo: RouterPathInfo = new RouterPathInfo();
        routerPathInfo.history = !!urlAfterRedirects ? [urlAfterRedirects] : [];
        if (!!urlAfterRedirects && urlAfterRedirects.includes('result')) {
          const closeRoute = new CloseRoute(urlAfterRedirects, currentDomainCode );
          routerPathInfo.closeRoute = closeRoute;
        }

        const targetDomain =  this.route.snapshot.queryParams['_domains'];
        // test conservé par sécurité, mais normalement plus nécessaire car le changement de domaine potentiel se fait maintenant dans les resolvers
        if ( (!!targetDomain && !!currentDomainCode && targetDomain!==currentDomainCode) || (!!targetDomain && !currentDomainCode) ) {
          let urlPart = null;
          if (urlAfterRedirects.includes('/'+Url.DOCUMENTS)) {
              urlPart = Url.DOCUMENTS;
          } else if (urlAfterRedirects.includes('/'+Url.LINKS)) {
                urlPart = Url.LINKS;
          } else if (urlAfterRedirects.includes('/'+Url.TASKS)) {
              urlPart = Url.TASKS;
          } if (urlAfterRedirects.includes('/'+Url.SEARCH)) {
                urlPart = Url.SEARCH;
          }
          this.domainService.setCurrentDomainWithNavigation(targetDomain, urlPart)
        }
        else {
            this.menuService.calcAccessToDomainTeamsByCurrentDomain(currentDomainCode);
        }

        this.addPath(routerPathInfo);
        this.appHeadTitleAndIconService.setAppTitleAndIconFromUrl(urlAfterRedirects);
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub: Subscription) => sub.unsubscribe());
  }

  addPath(routerPathInfo: RouterPathInfo) {
    try {
      this.routerPathAction.loadRouterPathStart();
      if (routerPathInfo.history[0] === undefined || routerPathInfo.history[0] === null) {
        throw new ErrorEvent('path cannot be null or undefined');
      }
      this.routerPathAction.loadRouterPathSucceeded(routerPathInfo);
    } catch (error) {
      this.routerPathAction.loadRouterPathFailed(error);
    }
  }

  removeAll() {
    this.routerPathAction.removeAll();
  }
}
